import React, { useCallback, useEffect, useState, useContext, useRef } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { CloudDownloadOutlined, Print } from "@material-ui/icons";
import {
  defultReportPrintStyle,
  encryptData,
  printDocument,
} from "../../utils/utils";
import FeedbackReportItem from "../player/FeedbackReportItem";
import { SSOContext } from "../../context/SSOContext";
import SimPlayedSummaryService from "../../services/SimPlayedSummaryService";
import PersonalInfo from "./PersonalInfo";
import PersonalInfoDialog from "../generic/PersonalInfoDialog";
import SimResultService from "../../services/SimResultService";
import jsPDF from "jspdf";
import Loader from "../loader";
import CodeScoreService from "../../services/CodeScoreService";
import { PlayerContext } from "../../context/PlayerContext";
import MCEEResultService from "../../services/MCEEResultService";
import { SB_URL } from "../../Config";
import CoachingDebrief from "./CoachingDebrief";
import DebriefSummarySection from "./DebriefSummarySection";
import "./coaching.css";

/** Mirrors backend CoachingPhase order (0–5). */
const COACHING_PHASES = [
  { order: 0, label: "Getting started" },
  { order: 1, label: "Whole experience" },
  { order: 2, label: "Patterns" },
  { order: 3, label: "Decisions" },
  { order: 4, label: "Meaning" },
  { order: 5, label: "Transfer" },
];

const EndTrack = (props) => {
  const coachingLayout = props.coachingLayout === "split" ? "split" : "stacked";
  const isSplitLayout = coachingLayout === "split";
  const [viewedListOfTrack, setViewedListOfTrack] = useState([]);
  const ssoContext = useContext(SSOContext);
  const { playerState } = useContext(PlayerContext);
  const [isOpen, setIsOpen] = useState(true);
  const [simPlayedSummary, setSimPlayedSummary] = useState({});
  const [simPlayedSummaryId, setSimPlayedSummaryId] = useState();
  const [playSessionToken, setPlaySessionToken] = useState(null);
  const [isSavePdf, setIsSavePdf] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Please wait...");

  /** Full-page system loader; pass a string to show, or null/false to hide. */
  const setPageLoading = useCallback((message) => {
    if (message) {
      setLoadingMessage(String(message));
      setIsLoading(true);
    } else {
      setIsLoading(false);
      setLoadingMessage("Please wait...");
    }
  }, []);
  const [url, setUrl] = useState(null);
  /** 'report' = download/print flow; 'coaching' = required before starting AI coaching */
  const [personalInfoPurpose, setPersonalInfoPurpose] = useState("report");
  const personalInfoPurposeRef = useRef(personalInfoPurpose);
  personalInfoPurposeRef.current = personalInfoPurpose;
  const startCoachingAfterSaveRef = useRef(null);
  const endSessionRef = useRef(null);
  const isCoachingPersonalInfo = personalInfoPurpose === "coaching";
  const [coachingStatus, setCoachingStatus] = useState("idle");
  const [coachingPhase, setCoachingPhase] = useState(0);
  const [coachingSessionEnding, setCoachingSessionEnding] = useState(false);
  const [debriefSummary, setDebriefSummary] = useState(null);
  const [debriefSkipReason, setDebriefSkipReason] = useState(null);
  const [transcriptVisible, setTranscriptVisible] = useState(true);
  const [activeSideTab, setActiveSideTab] = useState("transcript");
  const isActiveSession = coachingStatus === "active";
  const isCoachingCompleted = coachingStatus === "completed";

  useEffect(() => {
    props.setEndSimSession(true);
  }, []);

  // Lock the end-track main pane while coaching is active so only the side body scrolls.
  useEffect(() => {
    const mainPane = document.querySelector(
      ".player_content_main_end_track, .player_content_main_end_track_with_ad"
    );
    if (!mainPane) {
      return undefined;
    }
    if (isActiveSession) {
      mainPane.classList.add("player_content_main_end_track--coaching-active");
    } else {
      mainPane.classList.remove("player_content_main_end_track--coaching-active");
    }
    return () => {
      mainPane.classList.remove("player_content_main_end_track--coaching-active");
    };
  }, [isActiveSession]);

  useEffect(() => {
    if (simPlayedSummaryId && url == null && playerState.accountId != null) {
      setUrl(
        `${SB_URL}/public/feedbackReport/${encryptData(simPlayedSummaryId)}`
      );
    }
  }, [simPlayedSummaryId]);

  // Saving MCEE score if mceeSaveRequest and simPlayedSummaryId is present
  useEffect(() => {
    console.log("meceee-----------", props.linkAuditId,
        playerState.accountId,
        simPlayedSummaryId,
        playerState.simId,
        props.userId)
    if (
      props.linkAuditId &&
      playerState.accountId &&
      simPlayedSummaryId &&
      playerState.simId &&
      props.userId
    ) {
      console.log("inside mcee=================")
      const mceeVars = playerState.vars.filter(
        (variable) =>
          variable.type === "number" &&
          variable.name.trim().toLowerCase() === "mcee result" &&
          variable.variableContext &&
        (variable.currentValue != null || variable.currentValue != undefined)
      );
      if (mceeVars.length > 0) {
        const variableSum = mceeVars.map((mceeVar) => ({
          id: mceeVar.id,
          sum: mceeVar.currentValue,
        }));

        const saveRequest = {
          accountId: playerState.accountId,
          linkId: playerState.linkId,
          linkAuditId: props.linkAuditId,
          portalSimCode: playerState.portalSimCode,
          variableSum: variableSum,
          simCode: playerState.id,
          simPlayedSummaryId: simPlayedSummaryId,
          simId: playerState.simId,
          userId: parseInt(props.userId),
          playSessionToken,
        };

        MCEEResultService()
          .saveScore(saveRequest)
          .then((response) => {
            if (response.ok) {
              console.debug("saveScore", saveRequest);
            }
          })
          .catch((error) => {
            console.error("Error while saving score:", error);
          });
      }
    }
  }, [simPlayedSummaryId, props.userId, playerState]);

  useEffect(() => {
    const list = props.tracksViewedSummmary;
    const listOfTrackId = [];
    list.forEach((element) => {
      listOfTrackId.push(element.trackId);
    });
    setViewedListOfTrack(listOfTrackId);

    const responseData = {
      simId: props.simId,
      accId: playerState.accountId,
      linkId: playerState.linkId,
      linkAuditId: props.linkAuditId,
      portalSimCode: playerState.portalSimCode,
      viewedTracksList: JSON.stringify(listOfTrackId),
      simCode: props.simCode,
      playStartDate: props.simSessionStartDate
        ? props.simSessionStartDate
        : props.playDates.playStartDate,
      playEndDate: new Date(),
      simPlayUUID: props.simPlayUUID,
      userId: parseInt(props.userId),
      playType: localStorage.getItem("playType")
        ? localStorage.getItem("playType")
        : "",
      isJobCompleted: props.simResultList
        .filter((t) => t.trackType === "recorded")
        .every((t) => {
          try {
            const parsed = JSON.parse(t.response); // e.g. [""] or ["abc.mp4"]
            return (
              Array.isArray(parsed) &&
              parsed.every((v) => !v || v.trim() === "")
            );
          } catch {
            return false; // invalid JSON → treat as not completed
          }
        }),
    };
    SimPlayedSummaryService()
      .saveSimPlayedSummaryResult(responseData)
      .then((response) => {
        if (response.status === 200) {
          setSimPlayedSummaryId(response.data.id);
          setPlaySessionToken(response.data.playSessionToken);
          setSimPlayedSummary(response.data);
        } else {
          console.error(
            "Error: while saving sim played summary",
            response.message
          );
        }
      })
      .catch((e) => {
        console.error(e.message);
      });
  }, props.tracksListViewed);

  useEffect(() => {
    if (props.simResultList.length > 0 && simPlayedSummaryId && playSessionToken) {
      let res = props.simResultList.map((element) => {
        return { ...element, simPlayedId: simPlayedSummaryId, playSessionToken };
      });
      SimResultService().saveSimResult(res);
    }
  }, [props.simResultList, simPlayedSummaryId, playSessionToken]);

  useEffect(() => {
    if (props.codeScoreList?.length > 0 && simPlayedSummaryId && playSessionToken) {
      let codeScoreCollection = props.codeScoreList.map((codeScore) => {
        return {
          ...codeScore,
          simPlayedSummaryId: simPlayedSummaryId,
          playSessionToken,
        };
      });
      CodeScoreService().saveCodeScore(codeScoreCollection);
    }
  }, [props.codeScoreList, simPlayedSummaryId, playSessionToken]);

  const givePdf = (title, style) => {
    const div = document.getElementById("fullReport");
    printDocument(title, "Simulation Feedback Report", style, div.innerHTML);
  };

  const location = "Feedback Report";

  const printHandler = () => {
    setIsSavePdf(false);
    setPersonalInfoPurpose("report");
    if (!simPlayedSummary?.firstName) {
      setIsOpen(true);
    } else {
      givePdf(location, defultReportPrintStyle);
    }
  };

  const openPersonalInfoForCoaching = () => {
    const hasInfo = Boolean(
      String(simPlayedSummary?.firstName || "").trim() &&
        String(simPlayedSummary?.lastName || "").trim() &&
        String(simPlayedSummary?.email || "").trim()
    );
    if (hasInfo) {
      startCoachingAfterSaveRef.current?.(simPlayedSummary);
      return;
    }
    setPersonalInfoPurpose("coaching");
    setIsSavePdf(true);
    setIsOpen(true);
  };

  const registerStartAfterPersonalInfo = useCallback((fn) => {
    startCoachingAfterSaveRef.current = fn;
  }, []);

  const registerEndSession = useCallback((fn) => {
    endSessionRef.current = fn;
  }, []);

  const handleCoachingStatusChange = useCallback((nextStatus) => {
    setCoachingStatus(nextStatus);
    if (nextStatus === "active") {
      setTranscriptVisible(true);
      setActiveSideTab("transcript");
    }
  }, []);

  const handleCoachingSessionEndingChange = useCallback((ending) => {
    setCoachingSessionEnding(Boolean(ending));
  }, []);

  const handleDebriefSummaryChange = useCallback((nextSummary) => {
    setDebriefSummary(nextSummary || null);
    if (nextSummary) {
      setDebriefSkipReason(null);
    }
  }, []);

  const handleDebriefSummarySkipped = useCallback((reason) => {
    setDebriefSkipReason(reason || null);
    if (reason) {
      setDebriefSummary(null);
    }
  }, []);

  const savePdf = () => {
    setLoadingMessage("Please wait...");
    setIsLoading(true);
    const doc = new jsPDF({
      orientation: "p",
      unit: "px",
      format: "a1",
      putOnlyUsedFonts: true,
      floatPrecision: 16,
    });
    doc.html(document.getElementById("pdf-report").innerHTML, {
      callback: (doc) => {
        doc.save("Simulation Feedback Report.pdf");
        setIsLoading(false);
      },
      autoPaging: "text",
      margin: [8, 80, 8, 80],
      width: 1100,
      windowWidth: 1100,
    });
    isSavePdf && setIsSavePdf(false);
  };

  const saveHandler = () => {
    if (!simPlayedSummary?.firstName) {
      setPersonalInfoPurpose("report");
      setIsOpen(true);
      setIsSavePdf(true);
    } else {
      savePdf();
    }
  };

  const isAccreditationClient =
    ssoContext.accreditationClient === "false"
      ? false
      : ssoContext.accreditationClient;

  const isAiCoachingEnabled =
    ssoContext.aiCoachingEnabled === "false"
      ? false
      : !!ssoContext.aiCoachingEnabled;

  /** Hide the coaching panel after debrief completes; summary lives in the feedback report. */
  const showCoachingPanel =
    Boolean(simPlayedSummaryId) && isAiCoachingEnabled && !isCoachingCompleted;

  const reportIntro = (showToolbar) => (
    <div className="row mr-0">
      <div className={showToolbar ? "col-8" : "col-12"}>
        <p>
          Congratulations on completing the simulation. Let's take a look and
          see how you did!
        </p>
        {isAccreditationClient && (
          <div className="text-red">
            Instructions: If you played this simulation for an assignment or
            project and need to submit it, please click the save and download
            button (cloud with an arrow), click the Yes button, enter your
            information, and click Save and Download. You are welcome to play
            the simulation multiple times and save once you are happy with your
            results.
          </div>
        )}
      </div>
      {showToolbar && (
        <div className="col-4 text-right">
          <Tooltip title="Save Feedback Report" placement="bottom">
            <IconButton onClick={saveHandler}>
              <CloudDownloadOutlined fontSize="large" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Print Feedback Report" placement="bottom">
            <IconButton onClick={printHandler}>
              <Print fontSize="large" />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  );

  const reportBody = (isPdfMarkup) => (
    <div className="report">
      {simPlayedSummary?.firstName && (
        <PersonalInfo
          simPlayedSummary={simPlayedSummary}
          layout={isPdfMarkup}
        />
      )}
      {playerState.accountId != null && url != null && (
        <div className="report_item">
          <h2>
            Kindly access the below link within the next 10 to 15 minutes to
            view the complete Simulation Feedback Report.
          </h2>
          <div className="mt-1">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.preventDefault();
                window.open(url, "_blank");
              }}
            >
              {url}
            </a>
          </div>
        </div>
      )}
      <div className="report_item">
        <h2>Tracks Viewed Summary</h2>
        <div className="summary_main">
          {props.tracksViewedSummmary < 1 && "No tracks were played"}
          {props.tracksViewedSummmary.map((element, index) => {
            let appendWhenNotLastElement = "=>";
            if (index + 1 === props.tracksViewedSummmary.length) {
              appendWhenNotLastElement = "";
            }
            let result = element?.title + " ( " + element?.order + " ) ";
            return (
              <React.Fragment key={index}>
                <div className="report-item-summary">{result}</div>
                <div style={{ display: "inline-block" }}>
                  {appendWhenNotLastElement}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
      {props.answersList < 1 && "No questions were asked"}
      {props.answersList.map((response, index) => {
        return (
          <FeedbackReportItem
            {...response}
            resultId={props.simResultList[index]?.id}
            key={index}
          />
        );
      })}
      {(debriefSummary || debriefSkipReason) && (
        <DebriefSummarySection
          summary={debriefSummary}
          skipReason={debriefSkipReason}
          variant="report"
        />
      )}
    </div>
  );

  const reportMarkup = (isPdfMarkup, { showToolbar = true } = {}) => {
    const markupId = isPdfMarkup ? "pdf-report" : "fullReport";
    const fontChange = isPdfMarkup ? "font-change" : "";
    return (
      <div id={markupId}>
        <div className={fontChange}>
          <h1>Simulation Feedback Report</h1>
          {reportIntro(showToolbar)}
          {reportBody(isPdfMarkup)}
        </div>
      </div>
    );
  };

  const layoutClassName = !showCoachingPanel
    ? "endtrack-layout"
    : isSplitLayout
      ? "endtrack-layout endtrack-layout-split"
      : "endtrack-layout endtrack-layout-stacked";

  const coachingDebrief = showCoachingPanel ? (
    <CoachingDebrief
      simPlayedSummaryId={simPlayedSummaryId}
      simId={props.simId}
      accountId={playerState.accountId}
      linkId={playerState.linkId}
      linkAuditId={props.linkAuditId}
      simPlayUUID={props.simPlayUUID}
      personalInfo={simPlayedSummary}
      onRequirePersonalInfo={openPersonalInfoForCoaching}
      registerStartAfterPersonalInfo={registerStartAfterPersonalInfo}
      onStatusChange={handleCoachingStatusChange}
      onSessionEndingChange={handleCoachingSessionEndingChange}
      onPhaseChange={setCoachingPhase}
      onSummaryChange={handleDebriefSummaryChange}
      onSummarySkipped={handleDebriefSummarySkipped}
      registerEndSession={registerEndSession}
      onPageLoadingChange={setPageLoading}
    >
      {({ stage, transcript }) => (
        <div className="coaching-session-shell">
          <header className="coaching-session-header">
            <div className="coaching-session-header-left">
              <h1 className="coaching-session-title">Simulation Feedback</h1>
              <div
                className="coaching-phase-track"
                role="group"
                aria-label="Coaching phase progress"
              >
                {COACHING_PHASES.map((phase) => (
                  <span
                    key={phase.order}
                    title={phase.label}
                    aria-label={phase.label}
                    className={`coaching-phase-dot${
                      coachingPhase >= phase.order
                        ? " coaching-phase-dot-active"
                        : ""
                    }${
                      coachingPhase === phase.order
                        ? " coaching-phase-dot-current"
                        : ""
                    }`}
                  />
                ))}
                <span className="coaching-phase-label">
                  {
                    (
                      COACHING_PHASES.find((p) => p.order === coachingPhase) ||
                      COACHING_PHASES[0]
                    ).label
                  }
                  {" · "}
                  Step {Math.min(Math.max(coachingPhase, 0), 5) + 1} of{" "}
                  {COACHING_PHASES.length}
                </span>
              </div>
            </div>
            <div className="coaching-session-header-actions">
              <Tooltip title="Download" placement="bottom">
                <IconButton
                  onClick={saveHandler}
                  aria-label="Download"
                  className="coaching-session-icon-btn"
                >
                  <CloudDownloadOutlined />
                </IconButton>
              </Tooltip>
              <button
                type="button"
                className="coaching-session-text-btn"
                onClick={printHandler}
              >
                <Print fontSize="small" />
                <span>Print</span>
              </button>
              <button
                type="button"
                className="btn btn-outline coaching-hide-transcript-btn"
                onClick={() => setTranscriptVisible((v) => !v)}
              >
                {transcriptVisible ? "Hide transcript" : "Show transcript"}
              </button>
              <button
                type="button"
                className="coaching-end-session-btn coaching-end-session-btn-header"
                onClick={() => endSessionRef.current?.()}
                disabled={coachingSessionEnding}
                aria-disabled={coachingSessionEnding}
              >
                End session
              </button>
            </div>
          </header>
          <div
            className={`coaching-session-layout${
              transcriptVisible
                ? ""
                : " coaching-session-layout--transcript-hidden"
            }`}
          >
            <div className="coaching-session-stage-wrap">{stage}</div>
            {transcriptVisible && (
              <aside className="coaching-session-side">
                <div
                  className="coaching-session-tabs"
                  role="tablist"
                  aria-label="Session panels"
                >
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeSideTab === "transcript"}
                    className={`coaching-session-tab${
                      activeSideTab === "transcript"
                        ? " coaching-session-tab-active"
                        : ""
                    }`}
                    onClick={() => setActiveSideTab("transcript")}
                  >
                    Transcript
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeSideTab === "report"}
                    className={`coaching-session-tab${
                      activeSideTab === "report"
                        ? " coaching-session-tab-active"
                        : ""
                    }`}
                    onClick={() => setActiveSideTab("report")}
                  >
                    Report
                  </button>
                </div>
                <div className="coaching-session-side-body">
                  {activeSideTab === "transcript" ? (
                    transcript
                  ) : (
                    <div className="coaching-session-report-panel">
                      <h1>Simulation Feedback Report</h1>
                      {reportIntro(false)}
                      {reportBody(false)}
                    </div>
                  )}
                </div>
              </aside>
            )}
          </div>
        </div>
      )}
    </CoachingDebrief>
  ) : null;

  const coachingColClassName = isActiveSession
    ? "coaching-session-host-inner"
    : isSplitLayout
      ? "endtrack-coaching-col"
      : undefined;

  return (
    <>
      <div
        className={
          isActiveSession ? "endtrack-layout coaching-session-host" : layoutClassName
        }
      >
        {showCoachingPanel && (
          <div className={coachingColClassName}>{coachingDebrief}</div>
        )}
        {!isActiveSession && (
          <main className="endtrack-report-col">{reportMarkup(false)}</main>
        )}
      </div>
      {isActiveSession && (
        <div className="coaching-session-print-source" aria-hidden="true">
          {reportMarkup(false)}
        </div>
      )}
      {reportMarkup(true)}
      {isOpen && (
        <PersonalInfoDialog
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          save={
            isCoachingPersonalInfo
              ? "Save, Download & Start Coaching"
              : `Save Info & ${isSavePdf ? "Download" : "Print"}`
          }
          title={
            isCoachingPersonalInfo
              ? "Personal Information Required"
              : "Personal Information"
          }
          message={
            isCoachingPersonalInfo
              ? "Personal information is required to start your AI Coaching Debrief. Enter your details below. Your feedback report will download, then coaching will begin."
              : undefined
          }
          discardTitle={
            isCoachingPersonalInfo
              ? "Leave without saving personal information?"
              : undefined
          }
          discardMessage={
            isCoachingPersonalInfo
              ? "Personal information is required to start AI Coaching. If you leave without saving, coaching cannot begin. Do you want to continue without saving?"
              : undefined
          }
          onSaved={(savedInfo) => {
            if (personalInfoPurposeRef.current === "coaching") {
              startCoachingAfterSaveRef.current?.(savedInfo);
            }
          }}
          simPlayedSummary={simPlayedSummary}
          setSimPlayedSummary={setSimPlayedSummary}
          isSavePdf={isSavePdf}
          pdf={(isSavePdf) => {
            if (isSavePdf) {
              savePdf();
            } else {
              givePdf(location, defultReportPrintStyle);
            }
          }}
          setIsLoading={setIsLoading}
          userId={props.userId}
          simPlayUUID={props.simPlayUUID}
          accountId={playerState.accountId}
          accreditationClient={
            ssoContext.accreditationClient === "false"
              ? false
              : ssoContext.accreditationClient
          }
          playSessionToken={playSessionToken}
        />
      )}
      {isLoading && (
        <div className="overlay">
          <Loader message={loadingMessage} />
        </div>
      )}
    </>
  );
};

export default EndTrack;
